export default __webpack_public_path__ + "static/faq-header-6134e8d924551b8140b5e97e08f60755.jpg";